import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Button from 'components/DesignSystem/Button';
import { ProductCardEntry } from 'helper/Home/productCardList';
import useProductLinks from 'utils/hooks/home/useProductLinks';

import './index.scss';

export default function ProductCard({
  product,
}: {
  product: ProductCardEntry;
}) {
  const links = useProductLinks(product.product, product.subproduct);

  return (
    <Card className="product-page-card">
      <Card.Title className="product-page-card-title">{product.name}</Card.Title>
      <Card.Body className="p-0 flex-grow-1 d-flex flex-column flex-justify-between">
        {links.length > 0 && (
          <Card.Text className="product-page-card-links d-flex mb-3" as="div">
            <div className="vertical-line" />
            <div className="subproduct-list d-flex flex-column">
              {links.map((l) => (
                <Link key={l.link} className="subproduct-entry" to={`/${l.link}`}>
                  {l.label}
                </Link>
              ))}
            </div>
          </Card.Text>
        )}
        {product.description && (
          <Card.Text className="product-page-card-description mb-3">{product.description}</Card.Text>
        )}
        <div className="d-flex justify-content-end mt-auto">
          <Link to={product.link} className="text-decoration-none">
            <Button type="secondary">Entrar</Button>
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
}
